import { pescexel } from 'helpers';
import React from 'react';

export default ({ idTabella }) => {
  return (
    <button type="button" className="btn btn-primary btn-sm rounded-pill" onClick={() => pescexel(idTabella)}>
      Export table
    </button>
  );
};
